import { UnauthenticatedHeader } from 'app/features/common/headers/unauthenticatedHeader'
import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'

const OutletWrapper = styled.div`
    flex: 1;
    display: grid;
    overflow-y: scroll;
`

export const UnauthenticatedRoute: FC = () => {
    return (
        <>
            <UnauthenticatedHeader />
            <OutletWrapper>
                <Outlet />
            </OutletWrapper>
        </>
    )
}
